import SectionHeading from '@/components/feature/SectionHeading';
import { recommendations } from '@/mocks/recommendations';

interface WatchlistSectionProps {
  watchlist: string[];
  onToggleWatch: (id: string) => void;
}

export default function WatchlistSection({ watchlist, onToggleWatch }: WatchlistSectionProps) {
  const items = recommendations.filter((r) => watchlist.includes(r.id));

  return (
    <section id="watchlist" className="w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="我的追番清单"
          title="把感兴趣的条目先收进来"
          desc="在上面的推荐区点击「加入追番」，条目就会出现在这里。清单保存在你自己的浏览器里，用于集中查看与规划观看顺序，不需要注册账号。"
        />

        {items.length === 0 ? (
          <div className="rounded-lg border border-dashed border-background-300 bg-background-100 px-6 py-14 text-center">
            <span className="inline-flex w-14 h-14 items-center justify-center rounded-full bg-accent-100 text-accent-700 text-2xl">
              <i className="ri-bookmark-line"></i>
            </span>
            <p className="mt-4 text-sm md:text-base text-foreground-600">
              清单还是空的，回到
              <a href="#recommend" className="mx-1 text-primary-600 font-medium cursor-pointer hover:underline">
                新番推荐
              </a>
              挑几部感兴趣的作品吧。
            </p>
          </div>
        ) : (
          <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-5">
            {items.map((item) => (
              <li
                key={item.id}
                className="flex items-center gap-4 rounded-lg border border-background-200 bg-background-100 p-3 md:p-4"
              >
                <div className="w-16 h-20 md:w-20 md:h-24 shrink-0 rounded-md overflow-hidden bg-background-200">
                  <img src={item.image} alt={`${item.title} 封面`} title={`${item.title}`} className="w-full h-full object-cover object-top" />
                </div>
                <div className="min-w-0 flex-1">
                  <h3 className="font-heading text-base md:text-lg text-foreground-950 truncate">{item.title}</h3>
                  <p className="mt-0.5 text-xs md:text-sm text-foreground-500 truncate">{item.season} · {item.episodes}</p>
                  <button
                    type="button"
                    onClick={() => onToggleWatch(item.id)}
                    className="mt-2 inline-flex items-center gap-1 text-xs md:text-sm text-foreground-600 hover:text-primary-600 cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-close-circle-line"></i>
                    移出清单
                  </button>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
}